import React from 'react';
import PropTypes from 'prop-types';
import { Field } from 'redux-form';
import { BodyText, CaptionText } from '@paypalcorp/pp-react';
import BasicRadioField from '../fields/BasicRadioField';
import BasicInputField from '../fields/BasicInputField';
import { formatAmount } from '../../utils/amountUtils';
import getLocaleMessages from '../../utils/localesMessages';
import { isHostedFlow } from '../../utils/buttonFactoryUtils';

const {
  anyAmount,
  fixedAmount,
  presetAmounts,
  presetHelperText,
  amount,
  amount1,
  amount2,
  amount3,
  otherAmount,
  title,
} = getLocaleMessages('buttonsV3/amountType');

const renderRadioField = (props) => {
  return <BasicRadioField {...props} />;
};

const renderAmountValueField = (props) => {
  return <BasicInputField {...props} />;
};

function AmountType({ receiverCurrency, amountType, handleAmountTypeChange }) {
  const formattedAmount = (value) =>
    value && formatAmount(value, receiverCurrency);

  return (
    <>
      <BodyText strong className="custom-margin-top custom-margin-bottom">
        {title}
      </BodyText>
      <Field
        type="radio"
        id="amountTypeVariable"
        name="amountType"
        value="variable"
        checkedValue={amountType}
        component={renderRadioField}
        onChange={handleAmountTypeChange}
        label={anyAmount}
      />

      <Field
        type="radio"
        id="amountTypeFixed"
        name="amountType"
        value="fixed"
        checkedValue={amountType}
        component={renderRadioField}
        onChange={handleAmountTypeChange}
        label={fixedAmount}
      />
      {amountType === 'fixed' ? (
        <div className="fixed-amount">
          <Field
            name="amountValue"
            id="amountValue"
            component={renderAmountValueField}
            label={amount}
            normalize={formattedAmount}
          />
        </div>
      ) : null}

      {isHostedFlow() && (
        <Field
          type="radio"
          id="amountTypePreset"
          name="amountType"
          value="merchant_recommended"
          checkedValue={amountType}
          component={renderRadioField}
          onChange={handleAmountTypeChange}
          labelClassName="three-amount-radio"
          label={presetAmounts}
          topLabel
          helperText={presetHelperText}
        />
      )}

      {amountType === 'merchant_recommended' && (
        <div className="preset-amount">
          <div className="amount-option">
            <Field
              name="merchantAmount1"
              id="merchantAmount1"
              component={renderAmountValueField}
              label={amount1}
              normalize={formattedAmount}
            />
          </div>
          <div className="amount-option">
            <Field
              name="merchantAmount2"
              id="merchantAmount2"
              component={renderAmountValueField}
              label={amount2}
              normalize={formattedAmount}
            />
          </div>
          <div className="amount-option">
            <Field
              name="merchantAmount3"
              id="merchantAmount3"
              component={renderAmountValueField}
              label={amount3}
              normalize={formattedAmount}
            />
          </div>
          <div className="amount-option other">
            <CaptionText className="other-amount">{otherAmount}</CaptionText>
          </div>
        </div>
      )}
    </>
  );
}

AmountType.propTypes = {
  receiverCurrency: PropTypes.string,
  amountType: PropTypes.string,
  handleAmountTypeChange: PropTypes.func,
};

export default AmountType;
